import { createComponent, createHook } from 'reakit-system';
import { Theme } from '@mos-cat/ds-theme';
import type { Property } from 'csstype';
import {
  color,
  ColorProps,
  compose,
  system,
  typography,
  TypographyProps,
} from 'styled-system';
import { StylesOptions, useStyles } from '../hooks/useStyles';
import { useTheme } from '../hooks/useTheme';
import { ecss, cx } from '../reexports/emotion';
import { BoxHTMLProps } from '../Box/Box';



const textDecoration = system({
  textDecoration: true,
});
const textScales = compose(typography, color, textDecoration);

export type TextOptions = TypographyProps<Theme> &
  ColorProps<Theme> & {
    textDecoration?: Property.TextDecoration;
  } & StylesOptions;

export type TextHTMLProps = BoxHTMLProps;

export type TextProps = TextOptions & TextHTMLProps;

export const useText = createHook<TextOptions, TextHTMLProps>({
  name: 'Text',
  keys: textScales.propNames,
  compose: [useStyles, useTheme],
  useProps(options, props) {
    return {
      ...props,
      className: cx(
        // @ts-expect-error
        props.className,
        ecss({ label: 'Text' }, textScales(options))
      ),
    };
  },
});

export const Text = createComponent({
  as: 'span',
  useHook: useText,
  memo: true,
});
